// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          searchPlaceholder: "What are you looking for?",
          novelty: "New",
          house: "House",
          apartment: "Apartment",
          rooms: "Rooms",
          lot: "Lot",
          condominium: "Condominium",
          building: "Building",
          tower: "Tower",
          farm: "Farm",
          local: "Local",
          land: "Land",
          independentHouse: "Independent House",
          penthouse: "Penthouse",
          townhouse: "Townhouse",
          loftApartment: "Loft Apartment",
          studioApartment: "Studio Apartment",
          luxuryHouse: "Luxury House",
          modern: "Modern",
          rustic: "Rustic",
          commercialProperty: "Commercial Property",
        },
      },
      es: {
        translation: {
          searchPlaceholder: "¿Qué estás buscando?",
          novelty: "Novedad",
          house: "Casa",
          apartment: "Apartamento",
          rooms: "Habitaciones",
          lot: "Lote",
          condominium: "Condominio",
          building: "Edificio",
          tower: "Torre",
          farm: "Finca",
          local: "Local",
          land: "Terreno",
          independentHouse: "Casa independiente",
          penthouse: "Penthouse",
          townhouse: "Townhouse",
          loftApartment: "Apartamento loft",
          studioApartment: "Apartamento estudio",
          luxuryHouse: "Casa de lujo",
          modern: "Moderna",
          rustic: "Rústica",
          commercialProperty: "Propiedad Comercial",
        },
      },
    },
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
